type MldApiResponse = {
  noValidOffers: boolean;
  html: string;
};

export default class MobileLeadDriverInit {
  private readonly _containerElement: HTMLElement;
  private _timeoutId: ReturnType<typeof setTimeout> | undefined = undefined;
  private _isMobile: boolean = false;
  private _coordinates: { lat: number; lon: number } | null = null;

  public constructor() {
    this._containerElement = document.getElementById(
      "mobileLeadDriverContainer"
    );
    this.initialize();
  }

  private readonly initialize = async () => {
    const deviceType = this._containerElement.dataset.mldDeviceType;
    const hasRestrictedOffers =
      this._containerElement.dataset.mldRestrictedOffers === "true";
    this._isMobile = DoUtility.isMobile;

    if (
      (this._isMobile && deviceType === "desktop") ||
      (!this._isMobile && deviceType === "mobile")
    ) {
      return;
    }

    if (hasRestrictedOffers) {
      this.tryGetLocation();
    } else {
      this.fetchMobileLeadDriver();
    }
  };

  private readonly tryGetLocation = () => {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(
        this.gotLocation,
        this.failedToGetLocation,
        { enableHighAccuracy: true }
      );
      this._timeoutId = setTimeout(() => this.failedToGetLocation(), 30000);
    } else {
      this.failedToGetLocation();
    }
  };

  private readonly gotLocation = async (position: GeolocationPosition) => {
    clearTimeout(this._timeoutId);
    this.fetchMobileLeadDriver(position);
  };

  private readonly failedToGetLocation = async () => {
    clearTimeout(this._timeoutId);
    this.fetchMobileLeadDriver();
  };

  private readonly fetchMobileLeadDriver = (position?: GeolocationPosition) => {
    const dealerId = window.DlronGlobal_DealerId;
    let path = `/api/forms/mobileLeadDriver?dealerId=${dealerId}`;
    const headers = { "Force-Replacement-Codes": "true" };
    if (position) {
      this._coordinates = {
        lat: position.coords.latitude,
        lon: position.coords.longitude,
      };
      path += `&lat=${position.coords.latitude}&lon=${position.coords.longitude}`;
    }
    fetch(path, { headers })
      .then((res) => res.json())
      .then((res) => this.renderMobileLeadDriver(res as MldApiResponse))
      .catch((err) => console.error(err.message, err));
  };

  private readonly renderMobileLeadDriver = async (mld: MldApiResponse) => {
    if (mld.noValidOffers) {
      return;
    }
    const { default: MobileLeadDriverForm } = await import(
      /* webpackChunkName: "mldForm" */ "./mobileLeadDriverForm"
    );
    new MobileLeadDriverForm(mld.html, this._isMobile, this._coordinates);
  };
}

DoUtility.SelfInstantiateOnLoad(MobileLeadDriverInit);
